// extracted by mini-css-extract-plugin
export default {"status":"change-order-status_status__Wt9Mg","card":"change-order-status_card__At0uu","button":"change-order-status_button__xkhni"};